import 'dayjs/locale/fr';
import { useTranslation } from 'react-i18next';
import Button from 'common/components/Button/Button';
import { Category } from 'types/Category';

const containerStyle =
  'white-box flex px-4 py-2 mb-2 w-full relative cursor-pointer transition-all overflow-hidden';

function CategoryItem({ item, onDelete, onNavigate }: any) {
  const { name, order } = item as Category;

  const { t } = useTranslation();

  return (
    <div className={`${containerStyle}  items-start lg:items-stretch flex-col lg:flex-row`}>
      <div className="w-full">
        <div className="responsive-flex-lg h-full items-center mb-4 lg:mb-0 w-full gap-6 lg:gap-4 pr:0 lg:pr-4">
          <div className="flex flex-col flex-1 pl-4 justify-start overflow-hidden">
            {/* head */}
            <div className="flex flex-col xl:flex-row w-full gap-4">
              <div className="flex flex-row justify-between flex-1">
                <h4 className="text-xl font-bold text-primary leading-6">{name}</h4>
              </div>
            </div>

            <div className="responsive-flex-lg mt-1" />

            {/* foot */}
          </div>
        </div>
      </div>

      {/* right */}
      <div className="flex flex-col justify-between text-xs w-full lg:border-l lg:pl-4 lg:w-[30em] lg:border-slate-150 gap-2">
        <div className="flex w-full gap-1 justify-end">
          <Button
            type="error-line"
            icon="TrashIcon"
            compact
            onClick={() => onDelete(item.id)}
            confirmMessage={t('actions.confirmDelete')}
          />

          <Button
            title={t('actions.edit')}
            type="warning-line"
            icon="PencilSquareIcon"
            onClick={() => onNavigate(item.id)}
          />
        </div>
      </div>
    </div>
  );
}

export default CategoryItem;
